import React from "react"
import { dateAndTime, EquifaxPrequalReport, EqDates } from "@oneethos/shared"
import { FiAlertTriangle } from "react-icons/fi"

type CreditReportHeaderProps = {
  item: any
  report: EquifaxPrequalReport
}

export const CreditReportHeader = ({
  item,
  report
}: CreditReportHeaderProps) => {
  const dateOfBirthString = item?.request?.dateOfBirth
  const age = EqDates.calculateAge(dateOfBirthString)
  const isElderlyCustomer = age !== null && age >= 65

  return <div className="cr-header">
    <div className="hdr-cont mb-1">
      <h5 className="m-0">
        Prequal: {item.customerName}
      </h5>
    </div>
    {item.comboName ? (
      <div className="help mb-1">
        Joint Application With: {item.comboName}
      </div>
    ) : null}
    <div className="help mb-1">{dateAndTime(new Date(item.createdDate))}</div>
    <div className="d-flex flex-row gap-3 my-2 fs-5">
      <div>Age: {age !== null ? age : 'N/A'}</div>
      {isElderlyCustomer &&
        <div className="alert alert-warning d-flex align-items-center gap-2 p-1 px-2 m-0">
          <FiAlertTriangle />
          <span>Elderly Customer</span>
        </div>}
    </div>
    <div className="badge bg-secondary mb-3">
      {report?.hitCode?.description}
    </div>
  </div>
}

